import { faBell, faCircle, faPhoneSlash, faShare, faStickyNote,faPaperPlane,faCircleXmark, 
     } from '@fortawesome/free-solid-svg-icons';
import { faCirclePause,
        faCirclePlay,
        faCircleCheck
    } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';
import ContactPrefIcon from "../../../../assets/icons/icon-contactPreferencesUpdated.svg";
import TodoCompletedPurple from "../../../../assets/icons/icon-TODOcompleted-bd65f0.svg";
import TodoCompletedTeal from "../../../../assets/icons/icon-TODOcompleted-teal.svg";
import TodoCompletedYellow from "../../../../assets/icons/icon-TODOcompleted-yellow.svg";
import TodoCompletedGreen from "../../../../assets/icons/icon-TODOcompleted-green.svg";
import TodoCompletedRed from "../../../../assets/icons/icon-TODOcompletedRed.svg";
import TodoCompletedBlue from "../../../../assets/icons/icon-TODOcompleted-blue.svg";

// https://andrej686575.invisionapp.com/console/i2i-Teletherapy-ckg94hwfa0p9v01egfzrs8xr4/clc9e44kx2b9n01bk2ex0ghr6/inspect
export const getVisibleDate = (dateString: string) => {
    const d = new Date(dateString);

    return moment(d).format('MM/DD/YY | HH:mm');
};

export const getIconNewUser = (row)=>{
    const iconString = row?.metadata?.uiDisplayIcon;

    switch (iconString) {
        case 'faBell':
            return faBell;
        case 'faCircleCheck':
            return faCircleCheck;
        case 'faCircle':
            return faCircle;
        case 'faPhoneSlash':
            return faPhoneSlash;
        case 'faShare':
            return faShare;
        case 'faStickyNote':
            return faStickyNote;
        case 'faPaperPlane':
            return faPaperPlane;
        case 'faPauseCircle':
            return faCirclePause;
        case 'faPlayCircle':
            return faCirclePlay;
        case 'faCircleXmark':
            return faCircleXmark;
        default:
            return faCircle;
    }

};

export const getSvgIcon = (row) => {
    const iconString = row?.metadata?.uiDisplayIcon;

    if(iconString === 'faPhoneSlash') {
            return <img src={ContactPrefIcon} alt=''/>;
    }else if(iconString === 'fabellCheck'){

        if(row?.metadata?.uiDisplayIconColor === "#bd65f0"){
            return <img src={TodoCompletedPurple} alt=''/>;  
        }

        if(row?.metadata?.uiDisplayIconColor === "#2AC9CF"){
            return <img src={TodoCompletedTeal} alt=''/>;  

        }

        if(row?.metadata?.uiDisplayIconColor === "#F5BB33"){
            return <img src={TodoCompletedYellow} alt=''/>;  

        }

        if(row?.metadata?.uiDisplayIconColor === "#10CE94"){
            return <img src={TodoCompletedGreen} alt=''/>;  

        }

        if(row?.metadata?.uiDisplayIconColor === "#F06565"){
            return <img src={TodoCompletedRed} alt=''/>;  

        }

        if(row?.metadata?.uiDisplayIconColor === "#6F7EEB"){
            return <img src={TodoCompletedBlue} alt=''/>;  

        }
    }
};